import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import Avatar5 from "../../../assets/img/avatar_5.svg";
import crossIcon from "../../../assets/img/icons/cross_black.svg";
import PlusBlack from "../../../assets/img/icons/plus_black_2.svg";
import BackButtonComponent from "../../../components/BackButtonComponent/BackButtonComponent";
import DropdownLoader from "../../../components/DropdownLoader/DropdownLoader";
import ButtonTextLoader from "../../../components/Loaders/ButtonTextLoader";
import PricingPlan from "../../../components/PricingPlan";
import {
  ButtonIcon,
  PrimaryButton,
  WhiteButton,
  WhiteButtonWithIcon,
} from "../../../styledComponents/buttons";
import {
  GeneralInfoItem,
  GeneralInfoSection,
  HoveredSection,
  InnerDivTooltip,
  RoundHover,
  ToolTipContainer,
  TooltipText,
} from "../../../styledComponents/clients";
import {
  CardTitle,
  CommonFlex,
  CommonGrid,
  CommonText,
  Container,
  ContentHeader,
  FormAlert,
  InputField,
  InputLabel,
  InputSection,
  InputWithLabelSection,
  ManagerBadge,
  PageTitle,
} from "../../../styledComponents/common";
import { ButtonFlexContainer } from "../../../styledComponents/members";
import { RedStar } from "../../../styledComponents/members";
import {
  AddOfficeContainer,
  AssigneeSection,
  CrossIcon,
  NameRoleSection,
  OfficeMemberDivContainer,
  officeMemberAvatar,
  officeMemberDiv,
  officeMemberRole,
} from "../../../styledComponents/offices";
import { checkHtml, checkUrl, validateEmail } from "../../../utils/helper";
import StaticTaskLocationModal from "../../ClientsNew/ClientDetails/StaticTaskLocationModal";
import { DataAndMapContainer } from "../../FieldServices/JobSites/jobSitesStyles";
import { MapAndAlertContainer } from "../../FieldServices/RouteMap/routeMapStyles";
import { AddAssigneeDropdown } from "../AddAssigneeDropdown";
import AddLocationModal from "../AddLocationModal";
import OfficeMembers from "./OfficeMembers";

const AddOffice = props => {
  const {
    isOfficeLimitFull,
    history,
    officeMembersList,
    selectedOrganization,
    clearOfficeDetails,
    clearCreatedOfficeId,
    officeLocation,
    officeLocationCreateUpdateSuccess,
    getOrganizationMembersShortList,
    createdOfficeId,
    getOfficeDetails,
    addOfficeMember,
    removeOfficeMember,
    createOffice,
    isLoading,
    memberShortListIsLoading,
    orgMembersShortList,
    officeMemberIsLoading,
    loadingMemberId,
    officeMemberListLoading,
    getOfficeMembersList,
    updateOfficeMember,
    updateOfficeInfo,
    addOfficeLocation,
    addOrUpdateOfficeLocalMapLoading,
  } = props;

  const [officeName, setOfficeName] = useState("");
  const [assignees, setAssignees] = useState([]);
  const [visibility, setVisibility] = useState(0);
  const [saveErrors, setSaveErrors] = useState({});

  const [popupOpen, setPopupOpen] = useState(false);
  const [pricingPopup, setPricingPopup] = useState(false);
  const [action, setAction] = useState("add");
  const { t } = useTranslation();
  const [locationInfo, setLocationInfo] = useState(null);
  const [chnagedOfficeName, setChnagedOfficeName] = useState(false);
  const [staticLocationModalOpen, setStaticLocationModalOpen] = useState(false);
  const [selectedStaticTaskLocation, setSelectedStaticTaskLocation] =
    useState(null);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const officeInputRef = useRef(null);

  const clearState = () => {
    clearCreatedOfficeId();
    clearOfficeDetails();
    setOfficeName("");
    setAssignees([]);
    setVisibility(0);
    setAction("add");
    setLocationInfo(null);
    setChnagedOfficeName(false);
    setStaticLocationModalOpen(false);
    setIsSubmitted(false);
  };

  const back = () => {
    history.push("/user/teams");
  };

  const onOfficeNameChange = e => {
    const { value } = e.target;
    setChnagedOfficeName(true);
    setOfficeName(value);

    if (saveErrors && saveErrors["officeName"]) {
      delete saveErrors["officetName"];
    }
  };

  useEffect(() => {
    officeInputRef.current.focus();
  }, []);

  useEffect(() => {
    if (officeLocation && officeLocation[0]) {
      setLocationInfo(officeLocation[0]);
    } else if (officeLocation !== null) {
      setLocationInfo(officeLocation);
    }
  }, [officeLocation, officeLocationCreateUpdateSuccess]);

  const cancelFunction = () => {
    history.push({
      pathname: "/user/team",
      state: { from: "create" },
    });
  };

  const checkError = () => {
    let saveErrors = {};
    let formIsValid = true;
    if (!officeName.trim()) {
      formIsValid = false;
      saveErrors["officeName"] = t("please_enter_team_name");
    } else if (checkUrl(officeName)) {
      formIsValid = false;
      saveErrors["officeName"] = t("team_name_can_not_contain_url");
    } else if (checkHtml(officeName)) {
      formIsValid = false;
      saveErrors["officeName"] = t("invalid_team_name");
    } else if (officeName.length > 256) {
      formIsValid = false;
      saveErrors["officeName"] = t(
        "please_enter_office_name_within_256_characters",
      );
    }
    setSaveErrors(saveErrors);
    return formIsValid;
  };

  useEffect(() => {
    return () => {
      clearState();
    };
  }, []);

  useEffect(() => {
    if (selectedOrganization && selectedOrganization.id) {
      let payload = {
        organization_id: selectedOrganization.id,
      };
      getOrganizationMembersShortList(payload);
    }
  }, [selectedOrganization]);

  useEffect(() => {
    if (officeMembersList && officeMembersList.length > 0) {
      let membersList = [];
      officeMembersList.map(member => {
        membersList.push({
          id: member.id,
          userId: member.user.id,
          name: `${member.user.first_name}${
            member.user.last_name ? ` ${member.user.last_name}` : ``
          }`,
          email: member.user.email,
          manageTeam: member.can_manage
            ? { value: "manager", label: "Team Manager" }
            : { value: "member", label: "Team Member" },
          avatar: member.user.avatar ? member.user.avatar : Avatar5,
          can_manage: member.can_manage,
        });
      });
      setAssignees(membersList);
    } else if (officeMembersList && officeMembersList.length === 0) {
      setAssignees([]);
    }
  }, [officeMembersList]);

  useEffect(() => {
    if (selectedOrganization && selectedOrganization.id && createdOfficeId) {
      let payload = {
        organization_id: selectedOrganization.id,
        office_id: createdOfficeId,
      };
      getOfficeDetails(payload);
    }
  }, [selectedOrganization, createdOfficeId]);

  useEffect(() => {
    if (isOfficeLimitFull && isSubmitted) {
      setPricingPopup(true);
    }
  }, [isOfficeLimitFull]);

  const updateAssingeeList = person => {
    if (selectedOrganization && selectedOrganization.id && createdOfficeId) {
      let payload = {
        organization_id: selectedOrganization.id,
        office_id: createdOfficeId,
        user_id: person.id,
      };
      addOfficeMember(payload);
    }
  };

  const handleDeleteMember = assigneeId => {
    if (
      selectedOrganization &&
      selectedOrganization.id &&
      createdOfficeId &&
      assigneeId
    ) {
      let payload = {
        organization_id: selectedOrganization.id,
        office_id: createdOfficeId,
        user_id: assigneeId,
      };
      removeOfficeMember(payload);
    }
  };

  const handleSave = () => {
    if (checkError()) {
      if (selectedOrganization && selectedOrganization.id) {
        let payload = {
          organization_id: selectedOrganization.id,
          name: officeName,
        };
        createOffice(payload);
        setIsSubmitted(true);
        // setTimeout(() => {
        //   history.push({
        //     pathname: "/user/offices",
        //     state: { from: "create" },
        //   });
        // }, 800);
      }
    }
  };

  const showAssignee = state => {
    setVisibility(state);
  };

  const handleUpdateOfficeMember = (canManage, memberId) => {
    if (
      selectedOrganization &&
      selectedOrganization.id &&
      createdOfficeId &&
      memberId
    ) {
      const payload = {
        organization_id: selectedOrganization.id,
        office_id: createdOfficeId,
        member_id: memberId,
        can_manage: canManage,
      };
      updateOfficeMember(payload);
    }
  };

  const handleRemoveOfficeMember = memberId => {
    if (
      selectedOrganization &&
      selectedOrganization.id &&
      createdOfficeId &&
      memberId
    ) {
      let payload = {
        organization_id: selectedOrganization.id,
        office_id: createdOfficeId,
        user_id: memberId,
        // getDetails: true,
      };
      removeOfficeMember(payload);
    }
  };

  const popupToggle = () => {
    setPopupOpen(!popupOpen);
    setAction("add");
  };

  const popupToggleUpdate = () => {
    setAction("update");
    setPopupOpen(!popupOpen);
  };

  const pricingPopupToggle = () => {
    setPricingPopup(!pricingPopup);
  };

  const handleSaveNameUpdate = () => {
    if (chnagedOfficeName) {
      if (checkError()) {
        if (selectedOrganization && selectedOrganization.id) {
          let payload = {
            organizationID: selectedOrganization.id,
            office_id: createdOfficeId,
            name: officeName,
          };
          updateOfficeInfo(payload);
          setTimeout(() => {
            history.push({
              pathname: "/user/teams",
              // state: { from: "create" },
            });
          }, 600);
        }
      }
    } else {
      back();
    }
  };

  const handleShowLocation = () => {
    setTimeout(() => {
      setStaticLocationModalOpen(true);
    }, 300);
  };

  return (
    <div className="content">
      <StaticTaskLocationModal
        isOpen={staticLocationModalOpen}
        toggle={() => {
          setStaticLocationModalOpen(false);
          setSelectedStaticTaskLocation(null);
        }}
        taskLocation={locationInfo !== null ? locationInfo : ""}
      />
      {isOfficeLimitFull && isSubmitted && pricingPopup ? (
        <PricingPlan
          isOpen={pricingPopup}
          toggle={pricingPopupToggle}
          popupText="You have reached the limit of creating offices."
          popupTitle="Upgrade to Standard or Elite to create unlimited offices."
          history={history}
          backRoute="/user/teams"
        />
      ) : null}
      <PageTitle>{t("teams")}</PageTitle>
      <ContentHeader>
        <BackButtonComponent
          onClick={() => back()}
          subTitle={t("back_to_all_teams")}
        />
      </ContentHeader>
      <Container style={{ padding: `30px` }}>
        <CardTitle>{t("add_team_details")}</CardTitle>

        <InputSection>
          <InputLabel>
            {t("team_name")} <RedStar>*</RedStar>
          </InputLabel>
          <InputField
            style={{ marginTop: "10px" }}
            width="25%"
            type="text"
            ref={officeInputRef}
            placeholder={t("type_team_name")}
            value={officeName}
            onChange={e => onOfficeNameChange(e)}
            error={
              saveErrors &&
              saveErrors["officeName"] &&
              saveErrors["officeName"] !== undefined
            }
          />
          {saveErrors &&
            saveErrors["officeName"] &&
            saveErrors["officeName"] !== undefined && (
              <FormAlert margin="0 0 0 5px">
                {saveErrors["officeName"]}
              </FormAlert>
            )}
        </InputSection>

        <CommonFlex gap="15px" margin="20px 0 0 0">
          {/* <WhiteButton type="cancel" onClick={() => cancelFunction()}>
                Cancel
              </WhiteButton> */}

          {!createdOfficeId && (
            <>
              <PrimaryButton
                width="25%"
                padding={isLoading ? "0 15px" : "0 35px"}
                onClick={!isLoading ? () => handleSave() : ""}
              >
                {isLoading ? (
                  <ButtonTextLoader loadingText="Saving" fontSize="13px" />
                ) : (
                  t("create_team")
                )}
              </PrimaryButton>
            </>
          )}
        </CommonFlex>

        {createdOfficeId && (
          <>
            <AssigneeSection>
              <CommonText $label>{t("assignee")}</CommonText>

              <AddAssigneeDropdown
                isLoading={memberShortListIsLoading}
                assignees={assignees}
                visibilityChange={showAssignee}
                updateState={updateAssingeeList}
                membersList={orgMembersShortList}
                getMembersList={getOrganizationMembersShortList}
                selectedOrganization={selectedOrganization}
                assigneeRemove={handleDeleteMember}
                officeMemberIsLoading={officeMemberIsLoading}
                loadingMemberId={loadingMemberId}
                office_id={createdOfficeId}
              />
            </AssigneeSection>

            {assignees && assignees.length > 0 && (
              <div style={{ marginTop: "25px", marginBottom: "25px" }}>
                <CommonText $label margin="0 0 15px 0">
                  Team Members
                </CommonText>

                <OfficeMembers
                  selectedOrganization={selectedOrganization}
                  officeId={createdOfficeId}
                  officeMemberListLoading={officeMemberListLoading}
                  getOfficeMembersList={getOfficeMembersList}
                  membersList={officeMembersList}
                  updateMember={handleUpdateOfficeMember}
                  deleteMember={handleRemoveOfficeMember}
                  officeMemberIsLoading={officeMemberIsLoading}
                  loadingMemberId={loadingMemberId}
                  history={history}
                />
              </div>
            )}

            <CommonText margin="10px 0" $label>
              {t("location")}
            </CommonText>
            {officeLocation && officeLocation.length !== 0 ? (
              <>
                <GeneralInfoSection
                  style={{ cursor: "pointer" }}
                  onClick={() => handleShowLocation()}
                >
                  <GeneralInfoItem>
                    <CommonText title>
                      {locationInfo && locationInfo.address
                        ? locationInfo.address
                        : ""}
                    </CommonText>
                    <CommonText $label fontWeight="500">
                      {locationInfo && locationInfo.name
                        ? locationInfo.name
                        : ""}
                    </CommonText>
                  </GeneralInfoItem>
                </GeneralInfoSection>
                <ButtonFlexContainer>
                  <WhiteButtonWithIcon onClick={() => popupToggleUpdate()}>
                    <ButtonIcon src={PlusBlack} alt="" />
                    {t("change_location")}
                  </WhiteButtonWithIcon>
                </ButtonFlexContainer>
              </>
            ) : (
              <>
                <GeneralInfoSection>
                  <GeneralInfoItem>
                    <CommonText title>{t("no_address_found")}</CommonText>
                    <CommonText $label fontWeight="500">
                      {t("no_name_set")}
                    </CommonText>
                  </GeneralInfoItem>
                </GeneralInfoSection>
                <ButtonFlexContainer>
                  <WhiteButtonWithIcon onClick={() => popupToggle()}>
                    <ButtonIcon src={PlusBlack} alt="" />
                    {t("add_location")}
                  </WhiteButtonWithIcon>
                </ButtonFlexContainer>
              </>
            )}

            <div style={{ margin: "10px  0 0 0" }}>
              <PrimaryButton
                onClick={() => handleSaveNameUpdate()}
                padding="0 30px"
              >
                Save & Close
              </PrimaryButton>
            </div>
          </>
        )}

        {locationInfo && locationInfo.name ? (
          selectedOrganization && selectedOrganization.id ? (
            <AddLocationModal
              isOpen={popupOpen}
              toggle={popupToggleUpdate}
              addOfficeLocation={updateOfficeInfo}
              addOrUpdateOfficeLocalMapLoading={
                addOrUpdateOfficeLocalMapLoading
              }
              createdOfficeLocationInfo={officeLocation}
              officeLocationCreateUpdateSuccess={
                officeLocationCreateUpdateSuccess
              }
              organization_id={selectedOrganization.id}
              office_id={createdOfficeId}
              id={locationInfo.id}
              action={action}
              name={locationInfo.name}
              address={locationInfo.address}
              radius={locationInfo.radius}
              latitude={locationInfo.latitude}
              longitude={locationInfo.longitude}
            />
          ) : null
        ) : selectedOrganization && selectedOrganization.id ? (
          <AddLocationModal
            isOpen={popupOpen}
            toggle={popupToggle}
            addOfficeLocation={addOfficeLocation}
            addOrUpdateOfficeLocalMapLoading={addOrUpdateOfficeLocalMapLoading}
            createdOfficeLocationInfo={officeLocation}
            organization_id={selectedOrganization.id}
            office_id={createdOfficeId}
            action={action}
          />
        ) : null}
      </Container>
    </div>
  );
};

export default AddOffice;
